import { withPlugins, domEvents } from '@spon/plugins';

function SearchFocus({ node, plugins: { addEvents } }) {
	const input = node.querySelector('#c-label_button-input');
	let isFocused = false;

	function focusInput() {
		node.classList.add('is-focused');
		input.focus();
	}

	// function blurInput() {
	// 	node.classList.remove('is-focused');
	// 	input.blur();
	// }

	function onClick(event) {
		event.preventDefault();

		if (isFocused) {
			// blurInput();
		} else {
			focusInput();
		}

		isFocused = !isFocused;
	}

	function formSubmit(event) {
		event.preventDefault();
		const { target } = event;

		const $form = target.nodeName === 'FORM' ? target : target.form;
		if (isFocused) {
			$form.submit();
		} else {
			focusInput();
		}
	}

	addEvents({
		'click [data-search]': onClick,
		'click [data-submit]': formSubmit,
		'submit [data-search]': formSubmit,
	});
}

export default withPlugins(domEvents)(SearchFocus);
